'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticTooltipSlot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.pick');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactackleAutoposition = require('reactackle-autoposition');

var _common = require('./common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoPositionPropsKeys = Object.keys(_reactackleAutoposition.AutoPosition.propTypes);

var propTypes = _extends({}, _reactackleAutoposition.AutoPosition.propTypes, {
  /**
   * Determines should tooltip be closed by outside click
   */
  closeOnOutsideClick: _propTypes2.default.bool,
  /**
   * @ignore
   */
  positionX: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * @ignore
   */
  positionY: _propTypes2.default.oneOf(['top', 'bottom']),
  /**
   * @ignore
   */
  direction: _propTypes2.default.oneOf(['vertical', 'horizontal']),
  /**
   * @ignore
   */
  type: _propTypes2.default.oneOf(['outer', 'inner']),
  /**
   * @ignore
   */
  hideTooltip: _propTypes2.default.func.isRequired,
  /**
   * @ignore
   */
  onVisibleCallback: _propTypes2.default.func.isRequired,
  /**
   * @ignore
   */
  cleanEventListeners: _propTypes2.default.func.isRequired,
  /**
   * @ignore
   */
  toggleEventListener: _propTypes2.default.func.isRequired,
  /**
   * @ignore
   */
  allowedSlideOnCurrentEdge: _propTypes2.default.bool,
  /**
   * @ignore
   */
  allowedSlideOnOppositeEdge: _propTypes2.default.bool,
  /**
   * @ignore
   */
  allowedSlideOnAdjacentEdge: _propTypes2.default.bool
});

var defaultProps = {
  closeOnOutsideClick: true,
  type: 'outer',
  positionX: 'left',
  positionY: 'bottom',
  direction: 'vertical',
  allowedSlideOnCurrentEdge: false,
  allowedSlideOnOppositeEdge: false,
  allowedSlideOnAdjacentEdge: false
};

var StaticTooltipSlot = exports.StaticTooltipSlot = function (_Component) {
  _inherits(StaticTooltipSlot, _Component);

  function StaticTooltipSlot(props) {
    _classCallCheck(this, StaticTooltipSlot);

    var _this = _possibleConstructorReturn(this, (StaticTooltipSlot.__proto__ || Object.getPrototypeOf(StaticTooltipSlot)).call(this, props));

    _this.state = {
      tooltipRef: null
    };

    _this._handleTooltipRef = _this._handleTooltipRef.bind(_this);
    _this._handleOutsideClick = _this._handleOutsideClick.bind(_this);
    _this._applyOutsideListener = _this._applyOutsideListener.bind(_this);

    _this.props.onVisibleCallback(_this._applyOutsideListener);
    return _this;
  }

  _createClass(StaticTooltipSlot, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.cleanEventListeners();
    }
  }, {
    key: '_handleTooltipRef',
    value: function _handleTooltipRef(ref) {
      this.setState({ tooltipRef: ref });
    }
  }, {
    key: '_applyOutsideListener',
    value: function _applyOutsideListener() {
      var _props = this.props,
          toggleEventListener = _props.toggleEventListener,
          closeOnOutsideClick = _props.closeOnOutsideClick;


      if (!closeOnOutsideClick) return;
      var listener = {
        target: document,
        event: 'click',
        cb: this._handleOutsideClick
      };
      toggleEventListener(listener);
    }
  }, {
    key: '_handleOutsideClick',
    value: function _handleOutsideClick(e) {
      if (!this.state.tooltipRef.contains(e.target)) {
        this.props.hideTooltip();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var children = this.props.children;

      var autoPositionProps = (0, _lodash2.default)(this.props, AutoPositionPropsKeys);

      return !autoPositionProps.parent && !autoPositionProps.visible ? null : _react2.default.createElement(
        _reactackleAutoposition.AutoPosition,
        autoPositionProps,
        function (_ref) {
          var positionX = _ref.positionX,
              positionY = _ref.positionY;
          return typeof children !== 'function' ? children : children({
            positionX: positionX,
            positionY: positionY,
            tooltipRef: _this2._handleTooltipRef
          });
        }
      );
    }
  }]);

  return StaticTooltipSlot;
}(_react.Component);

StaticTooltipSlot.propTypes = propTypes;
StaticTooltipSlot.defaultProps = defaultProps;

exports.default = (0, _common.withEventListeners)(StaticTooltipSlot);


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-tooltip/dist/StaticTooltipSlot.js
// module id = 881
// module chunks = 0